import { onload as onloadModule0 } from "../../../../../../../src/layouts/index.ts";
import { onload as onloadModule1 } from "../../../../../../../src/layouts/main.ts";
import { onload as onloadModule2 } from "../../../../../../../src/ssg/articles/2025/04/10/playing-with-canvas.ts";

const onloadModules = [{ name: "src/layouts/index.ts#onload", onload: onloadModule0 }, { name: "src/layouts/main.ts#onload", onload: onloadModule1 }, { name: "src/ssg/articles/2025/04/10/playing-with-canvas.ts#onload", onload: onloadModule2 }];

for (const module of onloadModules) {
	try {
		module.onload();
	} catch (error) {
		console.error(`wirejs onload failed: ${module.name}`, error);
	}
}